export { default, getStaticProps } from 'src/pages/Jobs/pages/Jobs'
